import { render, staticRenderFns } from "./openPlatform.vue?vue&type=template&id=27ec56b8&scoped=true"
import script from "./openPlatform.vue?vue&type=script&lang=js"
export * from "./openPlatform.vue?vue&type=script&lang=js"
import style0 from "./openPlatform.vue?vue&type=style&index=0&id=27ec56b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ec56b8",
  null
  
)

export default component.exports